<template>
  <main-layout>
    <div class="wrap">
      <div class="middle container">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="home-banner-swiper"
          v-if="locationList && locationList.length"
        >
          <!-- slides -->
          <swiper-slide v-for="(item, index) of locationList" :key="index">
            <div
              class="location"
              @mouseenter="on_top_enter"
              @mouseleave="on_top_leave"
            >
              <img
                class="locationImg"
                @click="gotoLocation(item)"
                :src="JSON.parse(item.image)[0].key | imageUrl('', 2320, 732)"
                alt=""
              />
              <div class="advertisement" v-if="item.type == '2'">
                {{ $t("video.广告") }}
              </div>
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
            v-if="locationList.length && locationList.length > 1"
          ></div>
        </swiper>
        <div class="survey">
          <a href="http://manabang.mikecrm.com/ogYbOBW" target="_blank"
            >我们想更了解您的想学习/感兴趣的方向，点击参与调研>></a
          >
        </div>
        <!-- <div class="offlineCourse" v-if="offlineCourseNum">
          <h3 class="academyTitle">
            <a
              class="more"
              href="/academy/offlineCourse"
              target="_blank"
              v-if="offlineCourseNum > 4"
            >
              {{ $t("global.更多") }}
              <img
                data-v-6b650005
                data-v-26370297
                src="/static/home/images/morenext.jpg"
              />
            </a>
            {{ $t("global.付费课程") }}
          </h3>
          <ul class="list">
            <li v-for="item in offlineCourseList" :key="item.url">
              <a class="offline-course-card" :href="item.url" target="_blank;">
                <div class="left">
                  <span
                    class="status status-collecting"
                    v-if="item.status == 1"
                  ></span>
                  <span
                    class="status status-opening"
                    v-if="item.status == 2"
                  ></span>
                  <span
                    class="status status-closed"
                    v-if="item.status == 4"
                  ></span>
                  <span
                    class="status status-expired"
                    v-if="item.status == 3"
                  ></span>
                  <img :src="item.image | imageUrl('', 270, 360)" />
                </div>
                <div class="right">
                  <h5>{{ item.title }}</h5>
                  <p class="user">
                    <img
                      v-if="item.userAvatar"
                      :src="
                        item.userAvatar
                          | imageUrl('/static/profile_img_default.png', 60, 60)
                      "
                    />
                    {{ item.username }}
                  </p>
                  <p class="tag-wrap">
                    <span class="tag" v-for="tag in item.tags" :key="tag">{{
                      tag
                    }}</span>
                  </p>
                  <p class="info">
                    <span
                      class="price"
                      :class="{
                        'price-disabled':
                          (item.status < 3 &&
                            item.amount - item.saleAmount == 0) ||
                          item.status == 3 ||
                          new Date() > new Date(item.endTime),
                      }"
                      v-if="item.price"
                    >
                      ￥
                      <b>{{ item.price }}</b>
                    </span>
                    <span class="amount" v-if="item.saleAmount > 0"
                      >{{ item.saleAmount }}{{ $t("global.人已购买") }}</span
                    >
                  </p>
                </div>
              </a>
            </li>
          </ul>
        </div> -->
        <div class="channelBox">
          <div class="titleBox clearfix">
            <p class="titleName">{{ $t("global.学院") }}</p>
            <div class="updateChan" @click="updateChannel">
              + {{ $t("works.创建学习频道") }}
            </div>
          </div>
          <div class="typeOrder">
            <span
              :class="{ active: orderByType == 0 }"
              @click="changeOrder(0)"
              >{{ $t("global.默认排序") }}</span
            >
            <span
              :class="{ active: orderByType == 3 }"
              @click="changeOrder(3)"
              >{{ $t("works.最多视频") }}</span
            >
            <span
              :class="{ active: orderByType == 2 }"
              @click="changeOrder(2)"
              >{{ $t("works.最多成员") }}</span
            >
          </div>
          <div class="videoListBox clearfix">
            <router-link
              :to="`/subjectdetail/${item.id}/home?type=2`"
              target="_blank"
              class="videoBox"
              v-for="(item, i) in videoList"
              :key="i"
            >
              <div class="topBox">
                <img :src="item.banner | imageUrl('', 1080, 308)" alt="" />
              </div>
              <div class="botBox">
                <p class="title">
                  {{
                    language === "zh" ? item.title : item.enTitle || item.title
                  }}
                </p>
                <p class="subTitle">
                  {{
                    language === "zh"
                      ? item.introduction
                      : item.enIntroduction || item.introduction
                  }}
                </p>
                <p class="number">
                  <span>
                    {{ $t("global.视频") }}
                    <i>{{ item.videoCount || 0 }}</i>
                  </span>
                  <span>
                    {{ $t("global.成员") }}
                    <i>{{ item.memberCount || 0 }}</i>
                  </span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <pagination
          :pageSize="pagerParam.pageSize"
          :pageIndex="pagerParam.currentPage"
          :totalRecord="pagerParam.total"
          @OnCurrentChanged="OnCurrentPageChanged"
        />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import item from "../../components/item.vue";
import Pagination from "@/components/v2/Pagination";
import FilterTable from "../../components/FilterTable.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "ExploreSubject",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.学院"),
    };
  },
  components: {
    MainLayout,
    item,
    Pagination,
    FilterTable,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      offlineCourseList: [],
      offlineCourseNum: 0,
      selectedFilters: [],
      filterList: [],
      industryId: "",
      professionId: "",
      orderByType: 0,
      videoList: [],
      isLogin: localStorage.getItem("auth_token") !== null,
      pagerParam: {
        pageSize: 12,
        pageCount: 1,
        currentPage: 1,
        total: 1,
      },
      locationList: [],
      activeIndex: null,
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        effect: "fade",
        pagination: {
          el: ".swiper-pagination", //分页器作用对象
          clickable: true, //分页器小圆点是否可点击
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper.swiper;
            let activeIndex = swiper.activeIndex;
            this.activeIndex = activeIndex;
          },
        },
      },
    };
  },
  created() {
    this.getLocation();
    this.getOfflineCourseList();
    this.filterList = [
      {
        name: this.$t("global.行 业"),
        list: [],
      },
      {
        name: this.$t("global.专 业"),
        list: [],
      },
    ];
    this.$http.get("/api/common/categoryList").then((response) => {
      if (response.data.industryList) {
        for (var i = 0; i < response.data.industryList.length; i++) {
          this.filterList[0].list.push({
            name: response.data.industryList[i]["title"],
            value: response.data.industryList[i]["categoryId"],
            cat: 1,
          });
        }
      }
      if (response.data.professionList) {
        for (var i = 0; i < response.data.professionList.length; i++) {
          this.filterList[1].list.push({
            name: response.data.professionList[i]["title"],
            value: response.data.professionList[i]["categoryId"],
            cat: 2,
          });
        }
      }
    });
    this.GetVideoList();
    this.buriedPoint(47,0)
  },
  methods: {
    updateChannel() {
      if (this.isLogin) {
        this.$router.push("/subject/create/step1");
      } else {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      }
    },
    on_top_enter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    on_top_leave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    getLocation() {
      this.$http.get("/api/operations/list/6").then((res) => {
        if (res.code === "OK") {
          this.locationList = res.data;
          this.locationShow(this.locationList[0]);
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/click", params).then((res) => {
        //运营位点击
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
        item.isFunc = true;
      });
    },
    gotoLocation(item) {
      this.locationClick(item);
      this.openLocatione(item);
    },
    changeOrder(val) {
      this.pagerParam.currentPage = 1;
      this.orderByType = val;
    },
    GoToSubjectDetail(id) {
      this.$router.push("/subjectdetail/" + id);
    },
    getOfflineCourseList() {
      var urlReplace = function (str) {
        return str.replace(/&amp;/g, "&");
      };
      this.$http
        .get("/api/common/page", {
          params: {
            id: 3315,
          },
        })
        .then((res) => {
          if (res.code === "OK") {
            const arr = res.data.body.match(/<code>(.*)<\/code>/);
            if (arr.length === 2) {
              const data = arr[1]
                .replace(/"/g, "`")
                .replace(/&quot;/g, '"')
                .replace(/<[^a][^((?!\/a).)*][^>]*>/g, "");
              this.offlineCourseList = JSON.parse(data);
              this.offlineCourseList.map(function (item) {
                item.url = urlReplace(item.url);

                var now = new Date(),
                  endTime = new Date(item.endTime),
                  stock = item.amount - item.saleAmount;

                if (now > endTime) {
                  item.status = 3; //已结束
                } else if (stock == 0) {
                  item.status = 4; //已满员
                }
              });
              this.offlineCourseNum = this.offlineCourseList.length;
              this.offlineCourseList = this.offlineCourseList.slice(0, 4);
            }
          }
        });
    },
    GetVideoList() {
      let pageSize = this.pagerParam.pageSize;
      this.$http
        .get(
          "/api/topic/findList?industryId=" +
            this.industryId +
            "&professionId=" +
            this.professionId +
            "&orderByType=" +
            this.orderByType +
            "&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            pageSize +
            "&type=2"
        )
        .then((response) => {
          if (response.data) {
            this.videoList = response.data.list;
            this.pagerParam.pageCount = response.data.totalPage;
            this.pagerParam.currentPage = response.data.pageIndex;
            this.pagerParam.total = response.data.totalRecord;
          }
        });
    },
    FilterChanged() {
      this.industryId = "";
      this.professionId = "";
      this.pagerParam.currentPage = 1;
      for (var i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].cat == 1) {
          this.industryId = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 2) {
          this.professionId = this.selectedFilters[i].value;
        }
      }
      this.$forceUpdate();
      this.GetVideoList();
    },
    GotoUrl(url) {
      this.$router.push(url);
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetVideoList();
    },
    deleteFilter(index) {
      this.selectedFilters.splice(index, 1);
      this.FilterChanged();
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    orderByType: function () {
      this.GetVideoList();
    },
    activeIndex(val) {
      this.locationShow(this.locationList[val]);
    },
  },
};
</script>
<style>
.swiper-pagination {
  bottom: 12px !important;
}
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  opacity: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
}
.swiper-pagination-bullet-active {
  background: #ffffff;
}
</style>
<style lang="stylus" scoped>
.wrap {
  padding-top: 20px;
  background: #fff;
}

.survey {
  margin-top: 30px;
  padding: 10px;
  background: rgba(54, 100, 237, 0.1);
  text-align: center;

  a {
    font-size: 14px;
    font-weight: bold;
    color: #3664ED;
  }
}

.academyTitle {
  padding: 40px 0 20px;
  font-size: 24px;

  .more {
    float: right;
    color: #999;
    font-size: 12px;
    font-weight: normal;
    line-height: 33px;
  }
}

.top {
  padding-top: 0.6rem;
}

.offlineCourse {
  .list {
    overflow: hidden;

    li {
      float: left;
      width: 563px;
      margin: 0 30px 30px 0;
      border: 1px solid rgba(224, 224, 224, 1);

      &:nth-child(2n) {
        margin-right: 0;
      }

      .offline-course-card {
        display: block;
        height: 180px;
        position: relative;
        padding: 20px 20px 20px 175px;
        background: #fff;

        .left {
          position: absolute;
          top: 20px;
          left: 20px;
          width: 135px;
          height: 180px;

          img {
            width: 135px;
            height: 180px;
            border-radius: 4px;
          }

          .status {
            position: absolute;
            top: 4px;
            left: -9px;
            width: 72px;
            height: 35px;
            background-size: 100%;
          }

          .status-collecting {
            background-image: url('/static/contest_collecting_tag@3x.png');
          }

          .status-opening {
            width: 60px;
            background-image: url('/static/college_opening_tag@3x.png');
          }

          .status-closed {
            width: 60px;
            background-image: url('/static/college_closed_tag@3x.png');
          }

          .status-expired {
            width: 60px;
            background-image: url('/static/college_expired_tag@3x.png');
          }
        }

        .right {
          position: relative;
          height: 180px;

          h5 {
            height: 60px;
            font-size: 20px;
            line-height: 30px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #333;
          }

          .user {
            margin-top: 6px;
            color: #999;
            font-size: 12px;

            img {
              display: inline;
              width: 20px;
              height: 20px;
              margin-right: 5px;
              border-radius: 100%;
              vertical-align: middle;
              border: 1px solid #eee;
            }
          }

          .tag-wrap {
            height: 22px;
            margin-top: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .tag {
              display: inline-block;
              margin-right: 5px;
              padding: 0 4px;
              color: #3664ED;
              font-size: 12px;
              line-height: 20px;
              background: rgba(54, 100, 237, 0.1);
              border-radius: 3px;
            }
          }

          .info {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            color: #999;
            font-size: 12px;
            line-height: 16px;

            .price {
              color: #FC6240;

              b {
                font-size: 24px;
              }
            }

            .price-disabled {
              color: #ccc;
            }

            .amount {
              float: right;
            }
          }

          .btn-wrap {
            position: absolute;
            right: 0;
            bottom: 0;
            text-align: right;

            .btn {
              display: inline-block;
              width: 90px;
              height: 34px;
              background: #3664ED;
              color: #fff;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              line-height: 34px;
              border-radius: 20px;
            }

            .btn-disable {
              background: #eee;
              color: #999;
            }
          }
        }
      }
    }
  }
}

.top-filter {
  color: #000;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  zoom: 1;
  background: #fff;
}

.top-tabs {
  width: 140px;
  float: left;
  font-size: 0.26rem;
}

.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}

.top-tab.active {
  background-color: #fff;
  color: #333333;
}

.top-tab-contents {
  width: 1020px;
  float: left;
}

.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}

.filter-result .pre {
  margin-right: 0.4rem;
}

.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}

.filter-result .el-button-group {
  margin-right: 0.2rem;
}

.orderby {
  margin: 0 0 20px;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}

.orderby .add {
  float: right;
  color: #0060ff;
}

.orderby > label {
  display: inline-block;
  margin-right: 0.3rem;
}

.orderby .active {
  color: #0060ff;
}

.orderby label {
  cursor: pointer;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.16rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.vedio-list .el-row {
  margin: 0 -0.13rem;
}

.vedio-list .item {
  margin: 0.13rem;
  cursor: pointer;
}

.author-item {
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.4rem 0;
}

.author-info {
  float: left;
  width: 7.46rem;
  overflow: hidden;
  zoom: 1;
}

.author-avatar {
  width: 1.3rem;
  height: 1.3rem;
  float: left;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.author-content {
  width: 6.13rem;
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.07rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-name {
  font-size: 0.26rem;
  color: #333333;
}

.author-title {
  font-size: 0.16rem;
  color: #777777;
  margin: 0.1rem 0 0.2rem;
}

.author-focus {
  display: block;
  width: 1.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
}

.author-vedio {
  float: right;
  width: 8.6rem;
  margin: 0.07rem -0.05rem 0;
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.author-vedio-item {
  width: 25%;
  float: left;
  padding: 0 0.05rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-vedio-item img {
  width: 2.06rem;
  height: 1.16rem;
  display: block;
  margin: 0 auto;
}

.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url('/static/explore/user.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url('/static/explore/vediocount.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  font-size: 0.26rem;
}

.orderby .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-user {
  background: url('/static/explore/focusUser.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-video {
  background: url('/static/explore/focusVideo.png') no-repeat center center;
  background-size: contain;
}

.subject-list {
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
}

.subject-item {
  cursor: pointer;
  display: block;
  float: left;
  width: 565px;
  margin: 0 30px 30px 0;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(224, 224, 224, 1);
}

.subject-item:nth-child(2n) {
  margin-right: 0;
}

.subject-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
  padding: 0;
}

.subject-add:before {
  content: '';
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 7.8rem;
  height: 100px;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.subject-add:after {
  content: '';
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url('/static/explore/add.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}

.subject-img {
  display: block;
  height: 161px;
  width: 565px;
}

.subject-content {
  padding: 20px;
}

.subject-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subject-summary {
  height: 40px;
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  word-break: break-word;
}

.subject-count {
  margin-top: 15px;
  font-size: 12px;
  color: #999;
}

.subject-count span {
  margin-right: 10px;
}

.subject-count span i {
  color: #333;
}

.location {
  width: 1160px;
  height: 366px;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  .locationImg {
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .advertisement {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 4px;
    height: 16px;
    background: rgba(51, 51, 51, 0.4);
    border-radius: 0px 6px 0px 0px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }
}

.channelBox {
  width: 1110px;
  margin: 0 auto;
  padding-top: 68px;

  .titleBox {
    height: 66px;

    .titleName {
      float: left;
      height: 66px;
      font-size: 44px;
      font-weight: 600;
      color: #000000;
      line-height: 66px;
    }

    .updateChan {
      float: right;
      padding: 0 36px;
      height: 40px;
      background: #1C21B0;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 13px;
      cursor: pointer;
    }
  }

  .typeOrder {
    margin: 32px 0 30px 0;

    span {
      margin-right: 30px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      cursor: pointer;

      &:hover {
        color: #2026CC;
      }
    }

    .active {
      font-weight: 600;
      color: #0A0A0A;
    }
  }

  .videoListBox {
    .videoBox {
      float: left;
      width: 538px;
      height: 300px;
      border: 1px solid #EBEBEB;
      margin-right: 30px;
      margin-bottom: 40px;

      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
      }

      &:nth-child(2n) {
        margin-right: 0;
      }

      .topBox {
        width: 538px;
        height: 154px;
        position: relative;

        img {
          position: absolute;
          width: 538px;
          height: 154px;
          top: 0;
          left: 0;
        }
      }

      .botBox {
        padding: 16px 15px 0;

        .title {
          height: 30px;
          font-size: 20px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .subTitle {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          height: 40px;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin: 8px 0 16px 0;
        }

        .number {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;

          span {
            margin-right: 20px;

            i {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="stylus">
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
}

.swiper-pagination-bullet-active {
  width: 6px;
  height: 6px;
  background: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/pages/academy/home.vue